import React, { useState } from 'react';
import styled from 'styled-components';
import heart_icon from '../../../../images/heart-icon.png';
import heart_icon_on from '../../../../images/heart_icon.png';
import comment_icon from '../../../../images/comment_icon.png';
import { Link } from 'react-router-dom';

import likeAnimation from 'images/lottiefile/like_animation_red.json';
import LottieLoader from 'components/containers/common/LottieLoader';

function HeartIcon({ click }) {
  return (
    <H_icon onClick={click}>
      <img src={heart_icon}></img>
    </H_icon>
  );
}
function HeartIconOn({ click }) {
  return (
    <H_icon onClick={click}>
      <img src={heart_icon_on}></img>
    </H_icon>
  );
}

const lottieOptions = {
  loop: false,
  autoplay: true,
  renderer: 'svg',
  animationData: likeAnimation
}

const lottieStyle = {
  position: 'absolute',
  top: '-100%',
  left: '-100%',
  transform: 'translate(10%, 10%)' ,
  width: 'calc(100vw * (50.2 / 375))',
  height: 'calc(100vw * (45.8 / 375))',
}

export default function GroupCommunityIconbtnpage(props) {
  // 하트 버튼 클릭
  function likeClick() {
    props.likedataSubmit(props.item.no);
  }
  function nulikeClick() {
    props.likedeldataSubmit(props.item.no);
  }
  return (
    <Icon_list
      borderwidth={props.borderwidth}
      borderline={props.borderline}
      margintop={props.margintop}
    >
      <Icon_list_align>
        {
        props.item.liked_post === false ? (
          <HeartIcon click={likeClick} />
        ) : (
          props.isLikeAnimation && props.item.no === props.currentPostNo? 
          <AnimationBlock>
            <LottieLoader lottieOptions={lottieOptions} style={lottieStyle}/>
          </AnimationBlock>
           : 
          <HeartIconOn click={nulikeClick} />
        )}
        

        <Count_num>{props.item.total_like}</Count_num>
      </Icon_list_align>
      <Icon_list_align>
        <Link
          component={Commlink}
          to={`/group/${props.group_no}/post/${props.no}`}
        >
          <C_icon>
            <img src={comment_icon}></img>
          </C_icon>{' '}
          <Count_num>{props.length ? props.length : 0}</Count_num>
        </Link>
      </Icon_list_align>
    </Icon_list>
  );

  //   to={`campaigns/${props.item.no}/posts`}
}

const Icon_list = styled.ul`
  display: flex;
  align-items: center;
  padding: calc(100vw * (11 / 375)) 0;
  border: ${(props) => props.borderline};
  border-width: ${(props) => props.borderwidth};
  margin-top: ${(props) => props.margintop};
`;

const Icon_list_align = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Commlink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const H_icon = styled.a`
  display: block;
  width: calc(100vw * (20.1 / 375));
  height: calc(100vw * (18.9 / 375));
`;
const C_icon = styled.span`
  display: block;
  width: calc(100vw * (17.9 / 375));
  height: calc(100vw * (17.9 / 375));
  margin-left: calc(100vw * (15 / 375));
`;
const Count_num = styled.em` 
  font-size: calc(100vw * (9 / 375));
  font-weight: 500;
  color: #7f7f7f;
  margin-left: calc(100vw * (3.5 / 375));
`;

const AnimationBlock = styled.div`
  position: relative;
  width: calc(100vw * (20.1 / 375));
  height: calc(100vw * (18.9 / 375));
`;
